import React, {useCallback, useEffect, useMemo, useState} from 'react'
import {callSP} from '../../setup/axios/AxiosCallSP'

type Parametro = {
  text: string
  value: string
}

interface Options {
  parametros?: Parametro[] | undefined
  pollInterval?: boolean
  storage?: boolean
  setLoading?(load: boolean): any
}

type UseFetch = (
  url: string,
  options?: Options
) => {data: any; loading: boolean; error: boolean; refetch: () => void}

const useFetch: UseFetch = (
  url,
  options = {
    parametros: undefined,
    pollInterval: false,
    storage: false,
  }
) => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  //const [parametros, setparametros] = useState<any>([])


  const fetchData = useCallback(async () => {
    try {
      if (options?.setLoading) options?.setLoading(true)
      const {data} = await callSP(url, options.parametros)

      if (data.status !== '200') {
        throw data.result
      }
      setData(data.result)
      if (options?.setLoading) options?.setLoading(false)
      setError(false) 
    } catch (error: any) {
      if (options?.setLoading) options?.setLoading(false)
      setError(true)
    }
  }, [url])

  useEffect(() => {
    fetchData()
  }, [fetchData])

 

  const refetch = useCallback(() => {
    fetchData()
  }, [fetchData])



  return {data, loading, error, refetch}
}

export default useFetch
